// 角度计算相关方法
export function calculatePositionAngle( pos_right , pos_left ){
    return Math.atan2(
         pos_right.y  -  pos_left.y  ,
         pos_right.x  -  pos_left.x
    )
}

// 单位转换的相关方法
export function radToDegree( rad ){
    return rad / Math.PI  * 180
}

export function degreeToRad( degree ){
    return degree / 180 * Math.PI
}

export function percentToFloat( percentage ) {
    return percentage / 100;
}

// 计算位置的相关方法

export function matrixNewPosition( origin_center_pos , label_position , matrix_3d_array ) {
    // 计算对一个标定点 进行 matrix3D 变换后的坐标点

    let relative_position = {
        x : label_position.x - origin_center_pos.x ,
        y : label_position.y - origin_center_pos.y
    };

    // 这个参数位置要转置的 参考 https://developer.mozilla.org/en-US/docs/Web/CSS/transform-export function/matrix3d
    let [ a , e , i , m ,                        // [ a  b  c  d        [ x
          b , f , j , n ,                        //   e  f  g  h    *     y
          c , g , k , o ,                        //   i  j  k  l          z
          d , h , l , p ] = matrix_3d_array;     //   m  n  o  p ]        1 ]

    // 投影变换参考这里 https://en.wikipedia.org/wiki/Transformation_matrix
    let project_w =  m * relative_position.x + n * relative_position.y + o * 0 + p * 1;

    let new_relative_position = {
        x : ( a * relative_position.x + b * relative_position.y + c * 0 + d * 1 ) / project_w,
        y : ( e * relative_position.x + f * relative_position.y + g * 0 + h * 1 ) / project_w
    };

    return {
        x :  origin_center_pos.x  + new_relative_position.x  ,
        y :  origin_center_pos.y  + new_relative_position.y
    }
}
// 计算位置的相关方法 END


// 距离相关的计算方法
export function euclideanDistance( pos_a, pos_b) {
    return Math.sqrt(Math.pow(pos_b.x - pos_a.x,2) + Math.pow(pos_b.y - pos_a.y,2));
}

export function tanDistanceByDegree( angle , depth ) {  // TODO del
    //       /|  <--- angle
    //      / |   \
    //     /  |    \
    //    /   |     > ---- depth
    //   /____|    /
    //      |_____ <- return distance
    return Math.round( Math.tan( degreeToRad( angle ) ) * depth );
}


export function calcPositionShift( source_position , dist_position ){
    return {
        x : dist_position.x - source_position.x ,
        y : dist_position.y - source_position.y
    }
}
// 距离相关的计算方法 END

